import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { isEqual } from "lodash";
import { StrategyImport } from "../../../types/imports";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement);

function ELapGraph() {
  const strategyImport: StrategyImport | null = useSelector(
    (state: RootState) => state.imports?.importPreviews?.strategy,
    isEqual,
  );

  const { chartData, xMax } = useMemo(() => {
    if (!strategyImport?.data || !strategyImport.data.refLapData) {
      return {
        chartData: { labels: [], datasets: [] },
        xMax: 1,
      };
    }

    const refLapTime = strategyImport.data.refLapData[2];
    const refLapELap = strategyImport.data.refLapData[4];
    const eLapData: { x: number; y: number }[] = refLapELap.map(
      (lat: number, index: number) => ({
        x: refLapTime[index],
        y: lat,
      }),
    );

    // Calculate min and max values for x-axis range
    const xValues = eLapData.map((point) => point.x);
    const xMaxVal = xValues.length > 0 ? Math.max(...xValues) : 1;

    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "eLap",
            data: eLapData,
            pointRadius: 0,
            borderColor: "#A18B6B",
            borderWidth: 2,
            showLine: true,
          },
        ],
      },
      xMax: xMaxVal,
    };
  }, [strategyImport]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "eLap",
      },
    },
    scales: {
      x: {
        type: "linear" as const,
        min: 0,
        max: xMax,
        border: {
          color: "#ffffff",
        },
        grid: {
          color: "#505050",
        },
        ticks: {
          display: true,
          color: "#ffffff",
        },
        title: {
          display: true,
          text: "Time (s)",
          color: "#ffffff",
        },
      },
      y: {
        grid: {
          color: "#505050",
        },
        ticks: {
          display: true,
          color: "#ffffff",
        },
        border: {
          color: "#ffffff",
        },
        title: {
          display: true,
          text: "eLap (kW/h)",
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <div className={styles.container}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
}

export default ELapGraph;
